import styled, { css } from 'styled-components';

export const getStyleRulesForOl = (start?: number) => css`
  padding: 0;
  list-style: none;
  counter-reset: item ${start || 0};

  li {
    position: relative;
    padding-top: ${(props) => props.theme.sizes.xxsmall};
    padding-bottom: ${(props) => props.theme.sizes.xxsmall};
    padding-left: ${(props) => props.theme.sizes.xlarge};
    line-height: 1.5;
    counter-increment: item;
  }

  li:before {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.theme.sizes.medium};
    height: ${(props) => props.theme.sizes.medium};
    font-size: ${(props) => props.theme.sizes.xsmall};
    color: ${(props) => props.theme.palette.secondary.main};
    text-align: center;
    content: counter(item);
    border-radius: 100%;
    background-color: ${(props) => props.theme.palette.secondary[300]};
  }
`;

export const OrderedList = styled.ol`
  ${(props) => getStyleRulesForOl(props.start)};
`;
